import React from 'react';
import { FilterIcon } from 'lucide-react';
interface MobileFilterButtonProps {
  onClick: () => void;
}
export const MobileFilterButton = ({
  onClick
}: MobileFilterButtonProps) => {
  return <button className="bg-white text-blue-800 p-3 rounded-full shadow-lg flex items-center justify-center" onClick={onClick} aria-label="ফিল্টার দেখুন (View Filters)" data-id="element-172">
      <FilterIcon className="h-6 w-6" data-id="element-173" />
    </button>;
};